var map = {
	"./Clandestina.png": 4414,
	"./Kenny G - The Moment.png": 3094,
	"./Rasputin.png": 8058,
	"./alive.jpg": 4573,
	"./apocalypse-1600776027-tsCmgK4gEU.jpg": 4890,
	"./asur2.png": 6302,
	"./avatar2.jpg": 5956,
	"./avatar3.png": 3646,
	"./dj tenebros.png": 1850,
	"./gasolinadd.png": 1250,
	"./headphones.svg": 6485,
	"./headphonesLogo.svg": 688,
	"./ignite-1600419626-nHn4WXY79q.jpg": 5952,
	"./jalabibaby.png": 7976,
	"./left.svg": 8430,
	"./mahabharat.png": 4194,
	"./mylogo.png": 8148,
	"./mylogo_remove.png": 589,
	"./notAvailable.jpg": 4371,
	"./over-my-head-1602154826-mOiKzOJDe6.jpg": 4291,
	"./right.svg": 7695,
	"./searchMusic.svg": 797,
	"./searchMusicDisc.svg": 4634,
	"./searchMusicMp3.svg": 7103,
	"./shakedown.jpg": 2140,
	"./thesearch.png": 4006,
	"./want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.jpg": 2876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;